import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import EnforcementAppealsSearchState from "@publicPortal/pages/search/EnforcementAppeal/EnforcementAppealsSearchState";

const { initialSearchState: eaInitialState, initialFilterState: eaInitialFilter } = PublicPortalState.enforcementAppealInitialSearchState();

export interface EnforcementAppealsSearchSlice {
    enforcementAppealsSearch: EnforcementAppealsSearchState;
    setEnforcementAppealsSearch: (state: EnforcementAppealsSearchState) => void;
    updateEnforcementAppealsSearch: (partialState: Partial<EnforcementAppealsSearchState>) => void;
    updateEnforcementAppealsFilter: (partialFilter: Partial<EnforcementAppealsSearchState["filter"]>) => void;
    resetEnforcementAppealsFilter: () => void;
}

export const createEnforcementAppealsSearchSlice: StateCreator<EnforcementAppealsSearchSlice, [], [], EnforcementAppealsSearchSlice> = (set) => ({
    enforcementAppealsSearch: eaInitialState,
    setEnforcementAppealsSearch: (state) => set({ enforcementAppealsSearch: state }),
    updateEnforcementAppealsSearch: (partialState) =>
        set((state) => ({ enforcementAppealsSearch: { ...state.enforcementAppealsSearch, ...partialState } })),
    updateEnforcementAppealsFilter: (partialFilter) =>
        set((state) => ({
            enforcementAppealsSearch: { ...state.enforcementAppealsSearch, filter: { ...state.enforcementAppealsSearch.filter, ...partialFilter } },
        })),
    resetEnforcementAppealsFilter: () =>
        set((state) => ({ enforcementAppealsSearch: { ...state.enforcementAppealsSearch, filter: { ...eaInitialFilter } } })),
});

